import React from "react";
import { notAnEbook } from "../data/content";
import { surface } from "../data/theme";
import { getIcon } from "../utils/icons";
import { Punchline } from "./Punchline";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
const circleStyles = ["bg-navy text-gold", "bg-gold-gradient text-navy", "bg-violet text-white", "bg-navy/[0.07] text-navy"];
export function NotAnEbook() {
  return <Section labelledBy="ebook-title" className="bg-white text-center" waveTo={surface.navy} data-id="element-132" data-mp="3mdmj80151pc3">
      <Reveal data-id="element-133" data-mp="3hfbda0dyryz5">
        <SectionTitle id="ebook-title" title={notAnEbook.title} highlight={notAnEbook.highlight} after={notAnEbook.after} data-id="element-134" data-mp="3hiz3apk7a394" />
        <p className="mt-4 text-lg text-navy/75" data-id="element-135" data-mp="37iyi0y2rtd2a">{notAnEbook.subtitle}</p>
      </Reveal>
      <ul className="mt-10 grid grid-cols-2 gap-3 text-left sm:gap-4" data-id="element-136" data-mp="1aq6isnytqh22">
        {notAnEbook.items.map((item, i) => {
        const Icon = getIcon(item.icon);
        return <Reveal as="li" key={item.title} delay={i * 0.04} className="flex flex-col rounded-2xl border border-line bg-white p-4 shadow-[0_6px_24px_-14px_rgba(13,42,71,0.25)] sm:p-5" data-id="element-137" data-mp="15rv49zxl3idi" data-mpi={i}>
              <span className={`flex h-12 w-12 items-center justify-center rounded-full sm:h-14 sm:w-14 ${circleStyles[i % circleStyles.length]}`} data-id="element-138" data-mp="3s44v4xk0ik9m">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-139" data-mp="3i4474yb77fz3" />
              </span>
              <h3 className="mt-4 text-[15px] font-bold leading-snug text-navy sm:text-base" data-id="element-140" data-mp="3i675q6qf2hff">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-navy/70" data-id="element-141" data-mp="emm0gu75wf09">{item.text}</p>
            </Reveal>;
      })}
      </ul>
      <Reveal data-id="element-142" data-mp="3w3lz1mjsj9co">
        <Punchline text={notAnEbook.punchline} className="mt-10" data-id="element-143" data-mp="3w22li3pircel" />
      </Reveal>
    </Section>;
}